import React, { useContext, useEffect } from "react";
import { EditorContext } from "./EditorContext.js";
import { RicosContext } from "./RicosContext.js";
const ToolbarContext = React.createContext({
  contentId: "",
  isMobile: false,
  theme: {},
  locale: "en",
  helpers: {},
  plugins: [],
  t: (text) => text,
  linkPanelData: void 0,
  headingsData: void 0,
  linkSettings: {},
  experiments: {},
  toolbarSettings: {},
  getPublicCommands: () => ({}),
  portal: null,
  editorRef: null,
  toolbars: null,
  defaultLineSpacing: {}
});
const getSelectedNodes = (editor) => {
  const selection = editor.state.selection;
  const nodes = [];
  editor.state.doc.nodesBetween(selection.from, selection.to, (node) => {
    nodes.push(node);
  });
  return nodes;
};
const ToolbarContextProvider = ({
  children,
  value
}) => {
  const {
    adapter: { tiptapEditor }
  } = useContext(EditorContext);
  const { content } = useContext(RicosContext);
  const [_, setSelectedNodes] = React.useState([]);
  useEffect(() => {
    const updateContent = () => {
      const newSelectedNodes = getSelectedNodes(tiptapEditor);
      setSelectedNodes(newSelectedNodes);
      content.update(newSelectedNodes, tiptapEditor);
    };
    const onTransaction = ({ transaction }) => {
      if (transaction.storedMarksSet) {
        updateContent();
      }
    };
    tiptapEditor.on("transaction", onTransaction);
    tiptapEditor.on("update", updateContent);
    tiptapEditor.on("focus", updateContent);
    tiptapEditor.on("selectionUpdate", updateContent);
    return () => {
      tiptapEditor.off("transaction", onTransaction);
      tiptapEditor.off("update", updateContent);
      tiptapEditor.off("focus", updateContent);
      tiptapEditor.off("selectionUpdate", updateContent);
    };
  }, []);
  return /* @__PURE__ */ React.createElement(ToolbarContext.Provider, { value: { ...value } }, children);
};
const withToolbarContext = (WrappedComponent) => {
  return (props) => {
    const { t } = useContext(RicosContext);
    return /* @__PURE__ */ React.createElement(ToolbarContext.Consumer, null, (contexts) => /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, context: { ...contexts, t } }));
  };
};
export {
  ToolbarContext,
  ToolbarContextProvider,
  withToolbarContext
};
//# sourceMappingURL=ToolbarContext.js.map
